import { Link } from 'react-router-dom';

interface Article {
  id: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  isFeatured: boolean;
}

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const categoryLabels: Record<string, string> = {
    football: '足球',
    basketball: '篮球',
    tennis: '网球',
  };

  return (
    <Link
      to={`/article/${article.id}`}
      className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 no-underline flex flex-col"
    >
      <div className="relative overflow-hidden aspect-[16/9]">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {article.isFeatured && (
          <span className="absolute top-3 left-3 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
            精选
          </span>
        )}
        <span className="absolute top-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded-full whitespace-nowrap">
          {categoryLabels[article.category] || article.category}
        </span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 flex-1">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400 mt-auto pt-3 border-t border-background-200/70">
          <span>{article.author}</span>
          <div className="flex items-center gap-3">
            <span>{article.publishDate}</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}